<jhi-spinner *ngIf="loading || loadingFile"></jhi-spinner>
<jhi-alert></jhi-alert>
<div class="row justify-content-center mt-2">
  <div class="col-lg-11">
    <div class="card-wrapper card-space">
      <div class="card-body">
        <div class="card card-bg card-big" [ngClass]="{'border-bottom-card': !loadingFile}">
          <div class="d-flex mt-2 justify-content-center">
            <div class="d-flex align-items-center mb-3">
              <svg class="icon icon-danger">
                <use href="./content/svg/sprites.svg#it-warning-circle"></use>
              </svg>
              <span class="h5 mb-0 px-1 fw-bold text-uppercase" jhiTranslate="istanze.intRichiesta">INTEGRAZIONE RICHIESTA</span>
            </div>
          </div>
          <div class="container container-lg">
            <div *ngIf="integrazioneResponse">
              <div class="row">
                <div class="col-md-4">
                  <p class="fw-bold text-black mb-1" jhiTranslate="istanze.dataRichiesta">Data richiesta: </p>
                  <p>{{formatDate(integrazioneResponse.integrazione.dataRichiesta).toLocaleString(this.selectedLanguage!.toString(), {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                  })}}</p>
                </div>
                <div class="col-md-4">
                  <p class="fw-bold text-black mb-1" jhiTranslate="istanze.dataScadenza">Data scadenza: </p>
                  <p>{{formatDate(integrazioneResponse.integrazione.dataScadenza).toLocaleString(this.selectedLanguage!.toString(), {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                  })}}
                    <span
                      jhiTranslate="istanze.alle">alle</span> {{formatDate(integrazioneResponse.integrazione.dataScadenza).toLocaleTimeString(this.selectedLanguage!.toString(), {
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit"
                    })}}</p>
                </div>
                <div class="col-md-4">
                  <p class="fw-bold text-black mb-1" jhiTranslate="istanze.cdServizio">Codice servizio: </p>
                  <p>{{integrazioneResponse.integrazione.istanza.servizio.cdServizio}}</p>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <p class="fw-bold text-black mb-1"><span jhiTranslate="istanze.descrizione">Descrizione</span>:</p>
                  <p>{{integrazioneResponse.integrazione.nota}}</p>
                </div>
              </div>
              <div class="mt-2">
                <ul class="upload-file-list">
                  <div class="row" *ngIf="width < 1000">
                    <div *ngFor="let all of listaIstanzeAllegato; index as i">
                      <div class="box border-upload my-2" jhiDragDrop (fileDropped)="dropFileAllegato($event, i)"
                           *ngIf="!all.contenuto">
                        <div class="box d-flex justify-content-center pt-3 pb-3">
                          <input type="file" name="file" id="file" class="inputfile inputfile-4 d-none"
                                 accept="text/csv, text/plain, application/pdf, image/png, image/jpeg, application/zip"
                                 (change)="inserisciFileAllegato($event, i)"
                          />
                          <label for="file" class="mb-0">
                            <figure>
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17">
                                <path
                                  d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"/>
                              </svg>
                            </figure>
                            <p class="text-center mb-0">Carica file</p>
                            <p class="fs-6 text-center mb-0">{{all.descrizione}}</p>
                          </label>
                          <div class="d-flex justify-content-center" *ngIf="false">
                            <div class="progress-spinner progress-spinner-active mt-3 mb-3">
                              <span class="visually-hidden">Caricamento...</span>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex justify-content-center" *ngIf="false">
                          <p style="margin-top: -15px !important;"><strong>ATTENZIONE:</strong> Il file supera il limite
                            di grandezza
                            consentito (<strong>1MB</strong>)!</p>
                        </div>
                      </div>
                      <div class="border-uploaded p-3 my-2" *ngIf="all.contenuto">
                        <div class="d-flex justify-content-between w-100">
                          <div>
                            <li class="upload-file success p-2">
                              <svg class="icon icon-sm" aria-hidden="true">
                                <use href="./content/svg/sprites.svg##it-file"></use>
                              </svg>
                              <p>
                                <span class="visually-hidden">Caricamento file:</span>
                                {{all.fileName}}<span
                                class="upload-file-weight show">{{formatBytes(all.size, 2)}}</span>
                              </p>
                            </li>
                          </div>
                          <div>
                            <label class="px-2">
                              <input type="file" class="d-none" (change)="inserisciFileAllegato($event, i)">
                              <svg class="icon icon-primary cursor-pointer" aria-hidden="true">
                                <use href="content/svg/sprites.svg#it-pencil"></use>
                              </svg>
                            </label>
                            <span class="visually-hidden">Annulla caricamento file {{all.fileName}}</span>
                            <svg class="icon icon-danger cursor-pointer" aria-hidden="true"
                                 (click)="rimuoviContenuto(i)">
                              <use href="content/svg/sprites.svg#it-delete"></use>
                            </svg>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-6">
                            <p class="fw-bold text-black mb-1">Titolo: </p>
                            <p>{{all.descrizione}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="width >= 1000">
                    <table class="mt-2 w-100">
                      <caption class="d-none">Tabella allegati integrazione</caption>
                      <tr>
                        <th scope="col" class="text-center" jhiTranslate="istanze.titolo">Titolo</th>
                        <th scope="col" class="text-center" jhiTranslate="istanze.note">Note</th>
                        <th scope="col" class="text-center" jhiTranslate="istanze.stato">Stato</th>
                        <th scope="col" class="text-center" jhiTranslate="istanze.azioni">Azioni</th>
                      </tr>
                      <tr *ngFor="let all of listaIstanzeAllegato; index as i" class="border-bottom">
                        <td class="col-auto">
                          <div class="d-flex justify-content-center"> {{all.titolo}}</div>
                        </td>
                        <td class="col-auto">
                          <div class="d-flex justify-content-center">{{all.descrizione || ' - '}}</div>
                        </td>
                        <td class="col-auto">
                          <div class="d-flex justify-content-center">
                            <span class="badge bg-success" *ngIf="all.contenuto; else mancante"
                                  jhiTranslate="istanze.allegati.inserito">Inserito</span>
                            <ng-template #mancante>
                              <span class="badge bg-danger" jhiTranslate="istanze.allegati.mancante">Mancante</span>
                            </ng-template>
                          </div>
                        </td>
                        <td class="col-auto">
                          <div class="d-flex justify-content-center">
                            <svg class="icon icon-primary grow c-pointer" data-bs-toggle="modal"
                                 data-bs-target=".bd-example-modal-lg" (click)="curIndex = i" *ngIf="!all.contenuto">
                              <use href="content/svg/sprites.svg#it-upload"
                                   xlink:href="./content/svg/sprites.svg##it-upload"></use>
                            </svg>
                            <svg class="icon icon-primary grow c-pointer" data-bs-toggle="modal"
                                 data-bs-target=".bd-example-modal-lg" (click)="curIndex = i" *ngIf="all.contenuto">
                              <use href="content/svg/sprites.svg#it-pencil"
                                   xlink:href="./content/svg/sprites.svg##it-pencil"></use>
                            </svg>
                            <svg class="icon icon-danger grow c-pointer" (click)="rimuoviContenuto(i)" *ngIf="all.contenuto">
                              <use href="content/svg/sprites.svg#it-delete"
                                   xlink:href="./content/svg/sprites.svg##it-delete"></use>
                            </svg>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </ul>
              </div>
              <div class="row align-middle mt-3">
                <div class="col-lg-12">
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <button type="button" class="btn btn-primary btn-sm" (click)="goBack()">
                <svg class="icon icon-sm icon-white">
                  <use href="./content/svg/sprites.svg#it-arrow-left"></use>
                </svg>
                <span jhiTranslate="istanze.indietro" class="text-uppercase">INDIETRO</span>
              </button>
              <button class="btn btn-success btn-sm btn-icon" type="button" (click)="integraIstanza()"
                      [disabled]="loadingFile"><span jhiTranslate="istanze.nuovo.invia"
                                                     class="text-uppercase">INVIA</span>
                <svg class="icon icon-sm icon-white">
                  <use href="./content/svg/sprites.svg#it-check"></use>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modale upload allegato -->
<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="modalUploadAll"
     aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title h5" id="modalUploadAll">Carica allegato</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Chiudi finestra modale"
                #_MD_ALLEGATO></button>
      </div>
      <div class="modal-body">
        <div class="box border-upload my-2" jhiDragDrop (fileDropped)="dropFileAllegato($event, curIndex)">
          <div class="box d-flex justify-content-center pt-3 pb-3">
            <input type="file" name="file" id="fileUpload" class="inputfile inputfile-4 d-none"
                   accept="text/csv, text/plain, application/pdf, image/png, image/jpeg, application/zip"
                   (change)="inserisciFileAllegato($event, curIndex)"
            />
            <label for="fileUpload" class="mb-0">
              <figure>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17">
                  <path
                    d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"/>
                </svg>
              </figure>
              <p class="text-center mb-0">Carica file</p>
              <p class="fs-6 text-center mb-0"
                 *ngIf="listaIstanzeAllegato[curIndex] && listaIstanzeAllegato[curIndex]">{{listaIstanzeAllegato[curIndex].descrizione}}</p>
            </label>
            <div class="d-flex justify-content-center" *ngIf="false">
              <div class="progress-spinner progress-spinner-active mt-3 mb-3">
                <span class="visually-hidden">Caricamento...</span>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center" *ngIf="false">
            <p style="margin-top: -15px !important;"><strong>ATTENZIONE:</strong> Il file supera il limite
              di grandezza
              consentito (<strong>1MB</strong>)!</p>
          </div>
        </div>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>
